import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { AdTopBanner, AdInContent, AdBottomBanner } from '../components/AdSense';

const DueDateCalculatorPage = () => {
  const [lmpDate, setLmpDate] = useState('');
  const [cycleLength, setCycleLength] = useState('28');
  const [result, setResult] = useState(null);

  const addDays = (date, days) => { const r = new Date(date); r.setDate(r.getDate() + days); return r; };
  const formatDate = (date) => date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  const calculate = () => {
    if (!lmpDate) return;
    const lmp = new Date(lmpDate);
    const cycle = parseInt(cycleLength) || 28;
    const ovulationDay = cycle - 14;
    const conception = addDays(lmp, ovulationDay);
    const dueDate = addDays(lmp, 280);
    const today = new Date();
    const daysPregnant = Math.floor((today - lmp) / (1000 * 60 * 60 * 24));
    const weeksPregnant = Math.floor(daysPregnant / 7);
    const daysExtra = daysPregnant % 7;
    const daysRemaining = Math.floor((dueDate - today) / (1000 * 60 * 60 * 24));
    const trimester = weeksPregnant < 13 ? 1 : weeksPregnant < 27 ? 2 : 3;

    setResult({ dueDate, conception, weeksPregnant, daysExtra, daysRemaining, trimester, lmp });
  };

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <AdTopBanner />
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link><span className="mx-2">›</span>
            <span className="text-gray-400">Due Date Calculator</span>
          </nav>
          <h1 className="text-3xl font-bold text-white mb-4">Due Date Calculator</h1>
          <p className="text-gray-400 mb-6">Calculate your estimated due date based on your last menstrual period.</p>

          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
            <div className="space-y-4">
              <div className="flex flex-wrap items-center gap-4">
                <label className="text-gray-300 w-40">Last Menstrual Period</label>
                <Input type="date" value={lmpDate} onChange={(e) => setLmpDate(e.target.value)}
                  className="w-48 bg-[#0d0d0d] border-[#2a2a2a] text-white" />
              </div>
              <div className="flex flex-wrap items-center gap-4">
                <label className="text-gray-300 w-40">Cycle Length</label>
                <Input type="number" value={cycleLength} onChange={(e) => setCycleLength(e.target.value)}
                  className="w-20 bg-[#0d0d0d] border-[#2a2a2a] text-white" />
                <span className="text-gray-400">days</span>
              </div>
            </div>
            <Button onClick={calculate} className="mt-6 bg-cyan-600 hover:bg-cyan-500 text-white px-8">Calculate</Button>

            {result && (
              <div className="mt-6 p-5 bg-[#0d0d0d] border border-[#2a2a2a] rounded-xl">
                <div className="text-center mb-6">
                  <p className="text-gray-400 mb-2">Estimated Due Date</p>
                  <p className="text-3xl font-bold text-green-400">{formatDate(result.dueDate)}</p>
                  <p className="text-cyan-400 mt-2">You are {result.weeksPregnant} weeks and {result.daysExtra} days pregnant</p>
                  <p className="text-gray-500">Trimester {result.trimester} • {result.daysRemaining > 0 ? `${result.daysRemaining} days remaining` : 'Due any day!'}</p>
                </div>
                <div className="grid grid-cols-3 gap-4">
                  <div className="p-3 bg-[#1a1a1a] rounded-lg text-center"><p className="text-gray-400 text-sm">LMP Date</p><p className="text-white font-medium">{result.lmp.toLocaleDateString()}</p></div>
                  <div className="p-3 bg-[#1a1a1a] rounded-lg text-center"><p className="text-gray-400 text-sm">Conception</p><p className="text-white font-medium">{result.conception.toLocaleDateString()}</p></div>
                  <div className="p-3 bg-[#1a1a1a] rounded-lg text-center"><p className="text-gray-400 text-sm">Due Date</p><p className="text-white font-medium">{result.dueDate.toLocaleDateString()}</p></div>
                </div>
              </div>
            )}
          </div>
          <AdInContent />
          <div className="mt-6 flex flex-wrap gap-2 text-sm">
            <span className="text-gray-500">Related:</span>
            <Link to="/pregnancy-calculator" className="text-cyan-400 hover:text-cyan-300">Pregnancy Calculator</Link>
            <span className="text-gray-600">|</span>
            <Link to="/pregnancy-conception-calculator" className="text-cyan-400 hover:text-cyan-300">Conception Calculator</Link>
          </div>
          <AdBottomBanner />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DueDateCalculatorPage;
